export const PUSH_SNACKBAR_MESSAGE = 'global/snackbars/PUSH_SNACKBAR_MESSAGE';
export const PUSH_SNACKBAR_TRANSLATION_KEY =
  'global/snackbars/PUSH_SNACKBAR_TRANSLATION_KEY';
export const REMOVE_FROM_SNACKBAR = 'global/snackbars/REMOVE_FROM_SNACKBAR';
export const REMOVE_FROM_SNACKBAR_BY_TEXT =
  'global/snackbars/REMOVE_FROM_SNACKBAR_BY_TEXT';
